import { render, staticRenderFns } from "./SISarpras.vue?vue&type=template&id=01f6cf61&"
import script from "./SISarpras.vue?vue&type=script&lang=js&"
export * from "./SISarpras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports